import React from 'react';
import {connect} from "react-redux";
import { config } from "../app/config";
import {preloaderHide, preloaderShow, alert, refreshStorage} from "../actions";
import TranslationService from "../app/services/TranslationService";
import '../styles/language.scss';
import axios from "axios";

const buttonSize = '40px';

class LanguageComponentClass extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showMenu: false,
            img: true
        };
    };

    changeLanguage = (lang) => {
        this.setState({img: true});
        this.props.preloaderShow();
        TranslationService.loadHolmTranslations(lang, null, (lang) => this.changeLanguageCallback(lang));
    }

    changeLanguageCallback = (lang) => {
        if (this.props.user === null) {
            localStorage.setItem('language', lang);
            this.props.refreshStorage();
            this.props.preloaderHide();

            return;
        }

        let that = this;
        axios.put(config.apiAddress + '/settings/language', {language: lang})
            .then(function (response) {
                that.props.alert(TranslationService.trans(that.props.language, 'settings.language.actions.success'));
                localStorage.setItem('language', lang);
                that.props.refreshStorage();
                that.props.preloaderHide();
            }).catch(function(response) {
                that.props.alert(TranslationService.trans(that.props.language, 'settings.language.actions.failed'));
                that.props.preloaderHide();
            });
    }

    // used for displaying sign for languages without flag
    getImageAlt = (lang) => {
        switch (lang) {
            case 'ar':
                return 'ع';
            case 'jp':
            case 'jp-jp':
                return 'あ';
            case 'ru':
            case 'ru-kz':
                return 'Д';
            default:
                return lang.substring(0, 2);
        }
    }

    getFlagAddress = (lang) => {
        let additionalParameters = null;
        if (lang.length > 2) {
            additionalParameters = '?lang=' + lang.substring(0, 2);
        }

        if (lang === 'en') {
            lang = 'gb';
        } else {
            lang = lang.slice(-2).toLowerCase();
        }


        return 'https://design.icymat.com/public/flag/squared/' + lang + '.svg' + additionalParameters;
    }

    render() {
        return (
            <div className="language" style={{display: 'inline-block'}}>
                <div
                    className={"flag imd-bg-gray imd-text-70-gray"}
                    style={{width: buttonSize, height: buttonSize, borderRadius: '50px', cursor: 'pointer', textAlign: 'center', fontSize: '25px'}}
                    onClick={() => this.setState({showMenu: !this.state.showMenu})}
                >
                    <img
                        style={{width: buttonSize, height: buttonSize, borderRadius: '50px', display: this.state.img ? 'inline-block' : 'none'}}
                        src={this.getFlagAddress(this.props.language)}
                        alt={this.getImageAlt(this.props.language)}
                        onError={() => this.setState({img: false})}
                    />
                    <span style={{display: !this.state.img ? 'inline-block' : 'none'}}>{ this.getImageAlt(this.props.language) }</span>
                </div>

                <div className="submenu imd-shadow imd-bg-default" style={{display: this.state.showMenu ? 'block' : 'none'}}>
                    <ul>
                        <li className={"imd-text-contrast"} onClick={() => {this.changeLanguage('pl-pl'); this.setState({showMenu: !this.state.showMenu})}}>Polski</li>
                        <li className={"imd-text-contrast"} onClick={() => {this.changeLanguage('en'); this.setState({showMenu: !this.state.showMenu})}}>English</li>
                        <li className={"imd-text-contrast"} onClick={() => {this.changeLanguage('uk-ua'); this.setState({showMenu: !this.state.showMenu})}}>Українська</li>
                        <li className="imd-text-accent imd-border-color-accent" style={{borderTop: '1px solid'}}>Experimental</li>
                        {/*{config.env === 'dev' ? <li className={"imd-text-contrast"} onClick={() => {this.changeLanguage('de-de'); this.setState({showMenu: !this.state.showMenu})}}>Deutch (unofficial)</li> : ''}*/}
                        <li className={"imd-text-contrast"} onClick={() => {this.changeLanguage('et-ee'); this.setState({showMenu: !this.state.showMenu})}}>Eesti</li>
                        {/*<li className={"imd-text-contrast"} onClick={() => {this.changeLanguage('xc-pl'); this.setState({showMenu: !this.state.showMenu})}}>Kaszëbsczi</li>*/}
                        <li className={"imd-text-contrast"} onClick={() => {this.changeLanguage('kk-kz'); this.setState({showMenu: !this.state.showMenu})}}>Қазақ</li>
                        <li className={"imd-text-contrast"} onClick={() => {this.changeLanguage('ru-kz'); this.setState({showMenu: !this.state.showMenu})}}>Орыс</li>
                        {/*{config.env === 'dev' ? <li className={"imd-text-contrast"} onClick={() => {this.changeLanguage('jp-jp'); this.setState({showMenu: !this.state.showMenu})}}>日本語 (unofficial)</li> : ''}*/}
                        <li className={"imd-text-contrast"} style={{textAlign: 'right'}} onClick={() => {this.changeLanguage('ar'); this.setState({showMenu: !this.state.showMenu})}}>عربي</li>
                    </ul>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        language: TranslationService.getLanguage(state.user),
    }
};

export const LanguageComponent = connect(mapStateToProps, { preloaderShow, preloaderHide, alert, refreshStorage })(LanguageComponentClass);
